var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowPass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 3,
    stroke: "#A5ADBA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5567 9.43786C17.9475 9.90312 18.1429 10.1357 18.1429 10.5C18.1429 10.8643 17.9475 11.0969 17.5567 11.5621C16.2682 13.0962 13.5922 15.75 10.5 15.75C7.40777 15.75 4.73181 13.0962 3.44331 11.5621C3.05251 11.0969 2.85711 10.8643 2.85711 10.5C2.85711 10.1357 3.05251 9.90312 3.4433 9.43786C4.73181 7.90384 7.40777 5.25 10.5 5.25C13.5922 5.25 16.2682 7.90384 17.5567 9.43786Z",
    stroke: "#A5ADBA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPass);
export default __webpack_public_path__ + "static/media/showPass.7aede8b27463803a532b65d4c71142f1.svg";
export { ForwardRef as ReactComponent };